import { Response } from "../../types/response/Response";
import ApiUtils from "../../lib/ApiUtils";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  OperatorCreateDTO,
  OperatorDTO,
  OperatorUpdateDTO,
} from "../../types/operator/OperatorDTO";

export const operatorApiV1 = createApi({
  reducerPath: "_operator",
  baseQuery: ApiUtils.apiQuery("/v1"),
  tagTypes: ["_operators"],
  endpoints: (builder) => ({
    getOperators: builder.query<Response<OperatorDTO[]>, Partial<void>>({
      query: () => "operators",
      providesTags: ["_operators"],
    }),
    updateOperator: builder.mutation<void, Partial<OperatorUpdateDTO>>({
      query: (body) => ({
        url: "operators/" + body.id,
        method: "PATCH",
        body: { name: body.name, code_list: body.code_list },
      }),
      invalidatesTags: ["_operators"],
    }),
    createOperator: builder.mutation<void, Partial<OperatorCreateDTO>>({
      query: (body) => ({
        url: "operators",
        method: "POST",
        body,
      }),
      invalidatesTags: ["_operators"],
    }),
    deleteOperator: builder.mutation<void, Partial<number>>({
      query: (id) => ({
        url: "operators/" + id,
        method: "DELETE",
      }),
      invalidatesTags: ["_operators"],
    }),
  }),
});

export const {
  useGetOperatorsQuery,
  useUpdateOperatorMutation,
  useCreateOperatorMutation,
  useDeleteOperatorMutation,
} = operatorApiV1;
